// extracted by mini-css-extract-plugin
module.exports = {"menu":"Document_menu__1vnN4"};